"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.amountFormatter = exports.parseNumberToBigInt = exports.makeShortId = exports.getAddressFromHex = void 0;
const many_js_1 = require("@liftedinit/many-js");
const DEFAULT_MAX_DIGITS = 9;
const getAddressFromHex = (hex) => {
    const identity = many_js_1.Address.fromHex(hex);
    return identity.toString();
};
exports.getAddressFromHex = getAddressFromHex;
const makeShortId = (idString) => {
    return typeof idString === "string"
        ? `${idString.slice(0, 4)}...${idString.slice(-4)}`
        : "";
};
exports.makeShortId = makeShortId;
const parseNumberToBigInt = (v, maxDigits = DEFAULT_MAX_DIGITS) => BigInt(Math.round(v * 10 ** maxDigits));
exports.parseNumberToBigInt = parseNumberToBigInt;
const amountFormatter = (amt, minDigits = 0, maxDigits = DEFAULT_MAX_DIGITS) => {
    const amount = parseFloat(amt.toString()) / 10 ** maxDigits;
    const amountString = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: minDigits,
        maximumFractionDigits: maxDigits,
    }).format(amount);
    return amountString;
};
exports.amountFormatter = amountFormatter;
